import { EBuildingGatesType } from 'shared/types/filters/advanced/buildingGatesType';

export const mapBuildingGatesTypeLabel = {
  [EBuildingGatesType.Dock]: 'Докового типа',
  [EBuildingGatesType.Ground]: 'На нулевой отметке',
  [EBuildingGatesType.Ramp]: 'На пандусе',
};
